import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-cancel-success',
	template: 
	`
	<div class="card m-auto bg-success text-white " style="width: 19rem;">
	<div class="card-body">
		<h5 class="card-title">Successfully Unsubscribed!</h5>
	</div>
  </div>
	`,
})
export class CancelSuccessComponent implements OnInit {

	constructor() { }

	ngOnInit() {
	}

}
